<template>
  <div>
    <div class="pt-60 pb-20 fs-26 bold">{{info.moduleTitle}}</div>
    <div class="tab-mol carousel-mol">
      <el-carousel height="210px" indicator-position="none" :autoplay="false" :arrow="dataList.length > 1 ? 'hover' : 'never'" :loop="false">
        <el-carousel-item v-for="(item, i) in dataList" :key="i">
          <ul class="type-list">
            <li v-for="(o, j) in item" :key="j" @click="goDetail(o)">
              <div class="img-icon">
                <img :src="o.img" v-if="o.img"/>
              </div>
              <p class="bold mt-20">{{o.name}}</p>
            </li>
          </ul>
        </el-carousel-item>
      </el-carousel>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    info: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      dataList: [],
      navigationType: ''
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    getData () {
      let methods = 'getProductTypeList'
      this.navigationType = this.info.extra ? this.info.extra.navigationType : ''
      let params = {
        sortLevel: 1,
        showFlag: 1,
        sort: 0
      }
      if (this.navigationType === 1) {
        methods = 'getSoftWareSystemsList'
        params = {}
      }
      this.API.product[methods]({
        currentPage: 1,
        pageSize: 500,
        ...params
      }).then((res) => {
        let data = res.data || []
        data.map(o => {
          o.name = o.sortName || o.softwareSystemName
          o.img = o.systemPhoto ? o.systemPhoto.split(',')[0] : o.pictureUrl
          return o
        })
        if (data.length) {
          this.dataList = _.chunk(data, 6)
        }
      })
    },
    goDetail (o) {
      if (this.navigationType === 1) {
        this.$router.push({
          name: 'systemDetail',
          query: {
            id: o.softwareSystemUuid
          }
        })
      } else {
        this.$router.push({
          name: 'productDevType',
          query: {
            id: o.sortUuid
          }
        })
      }
    }
  }
}
</script>
